import ApiGet from "../../../../../api-controller-mod/api-serv/get-api/getApi";
import ApiPatch from "../../../../../api-controller-mod/api-serv/post-api/patchApi";
import { MockSetGroup } from "../../../../../component-controller-mod/component-serv/list-fs-cp/media-list-op/ts/setting-list-tier.type";

export const MockSetSubmission: MockSetGroup[] = [
  {
    id: 1,
    title: "Message visibility",
    description: "Configure how messages are displayed and managed",
    items: [
      {
        id: 1,
        title: "Auto-mark as read on open",
        description: "Automatically mark messages as read when opened",
        controlType: "toggle"
      }
    ]
  }
]

export type SubmissionSettingsResponse = {
  success: boolean;
  requestId: string;
  data: {
    module: string;
    settings: {
      read: {
        autoMarkOnOpen: boolean;
      };
    };
  };
};

export const getSubmissionSettings = () => ApiGet<SubmissionSettingsResponse>("/api/v1/settings/submission");

export type SubmissionUpdateBody = {
  read?: {
    autoMarkOnOpen?: boolean;
  };
};

//  change endpoint if your backend uses different path
export const patchSubmissionSettings = (body: SubmissionUpdateBody) => ApiPatch("/api/v1/settings/submission/update", body);